module.exports = __webpack_public_path__ + "img/calendar-25_fill.1db15d4e.svg";